import { render, staticRenderFns } from "./ApmsBasicPlantInfo.vue?vue&type=template&id=a85634a6&scoped=true&"
import script from "./ApmsBasicPlantInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicPlantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85634a6",
  null
  
)

export default component.exports